import {Type} from '@angular/core';

import {BaseFilter} from './base/base.filter';

export class AssetFilter extends BaseFilter {

    public type: string;

    public searchText: string;

    public constructor() {
        super();
    }

    protected getType(): Type<BaseFilter> {
        return AssetFilter;
    }
}
